import { websiteConfig } from './website';

export const i18nConfig = {
  'en-us': {
    default: true,
    path: 'en',
    locale: 'en-us',
    siteLanguage: 'en',
    ogLang: 'en_US',
    defaultTitle: websiteConfig.title,
    defaultTitleAlt: websiteConfig.titleAlt,
    defaultDescription: websiteConfig.description,
    headline: websiteConfig.headline,
    category: 'Category',
    categories: 'Categories',
    was: 'was',
    were: 'were',
    tagged: 'tagged with',
    recent: 'Recent',
    projects: 'projects',
    allCategories: 'All categories',
    entries: 'entries',
  },
};
